import { render, staticRenderFns } from "./Na.vue?vue&type=template&id=35799f76&scoped=true&"
import script from "./Na.vue?vue&type=script&lang=js&"
export * from "./Na.vue?vue&type=script&lang=js&"
import style0 from "./Na.vue?vue&type=style&index=0&id=35799f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35799f76",
  null
  
)

export default component.exports